import { render, staticRenderFns } from "./rewardBuildPartnersEdit_bak.vue?vue&type=template&id=57eb448e&scoped=true&"
import script from "./rewardBuildPartnersEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardBuildPartnersEdit_bak.vue?vue&type=script&lang=js&"
import style0 from "./rewardBuildPartnersEdit_bak.vue?vue&type=style&index=0&id=57eb448e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb448e",
  null
  
)

export default component.exports